import React, { FC } from 'react';
import TwField from '../../../components/TwFields/TwFields';
import TwAutocomplete, {
  TwAutocompleteOption
} from '../../../components/TwAutocomplete/TwAutocomplete';
import { USER_ROLE } from '../../../providers/User/User.model';
import { LOCATION_TYPE } from '../../../redux/api/load/load.model';
import { CreateLocationFormValues } from '../CreateLocation/CreateLocation';
import useAuth from '../../../providers/Auth/Auth.provider';
import { FormikErrors, FormikValues } from 'formik';
import { useGetCustomersQuery } from '../../../redux/api/customer/customerApi';

interface CustomerLocationFieldProps {
  values: CreateLocationFormValues;
  setFieldValue: FormikValues['setFieldValue'];
  disabled?: boolean;
}

export const CustomerLocationField: FC<CustomerLocationFieldProps> = ({
  values,
  setFieldValue,
  disabled
}) => {
  const {
    data: { userData }
  } = useAuth();

  const { data: customersData } = useGetCustomersQuery(
    {},
    {
      selectFromResult: ({ data = { content: [], total: 0 } }) => ({
        data: {
          content: data.content.map((customer) => ({
            id: customer.id,
            label: customer.name,
            value: customer.id
          })),
          total: data.total
        }
      })
    }
  );

  return values.type?.value !== LOCATION_TYPE.CUSTOMER ? null : userData?.role ===
    USER_ROLE.CUSTOMER_CONTACT ? (
    <TwField
      id="customer_id"
      name="customer_id"
      label="Location customer"
      value={userData.customer_contact?.customer.name}
      disabled
    />
  ) : (
    <TwAutocomplete
      id="customer_id"
      name="customer_id"
      label="Location customer"
      optionList={customersData.content}
      value={values.customer}
      onChange={(
        _,
        newValue: TwAutocompleteOption | null
      ): Promise<void> | Promise<FormikErrors<CreateLocationFormValues>> => {
        return setFieldValue('customer', newValue);
      }}
      disabled={disabled}
    />
  );
};
